/**
 * 认证表单弹窗组件
 */

import React from 'react';
import { Modal, Form, Select, Input, Upload, Button } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import type { UploadFile } from 'antd/es/upload/interface';
import type { Certification } from '../types';
import { COUNTRY_OPTIONS, CERTIFICATION_TYPE_OPTIONS } from '../constants';

const { TextArea } = Input;

interface CertificationModalProps {
    open: boolean;
    editingRecord: Certification | null;
    form: any;
    loading: boolean;
    fileList: UploadFile[];
    onFileListChange: (fileList: UploadFile[]) => void;
    onOk: () => void;
    onCancel: () => void;
}

export const CertificationModal: React.FC<CertificationModalProps> = ({
    open,
    editingRecord,
    form,
    loading,
    fileList,
    onFileListChange,
    onOk,
    onCancel,
}) => {
    return (
        <Modal
            title={editingRecord ? '编辑认证' : '添加认证'}
            open={open}
            onOk={onOk}
            onCancel={onCancel}
            width={700}
            confirmLoading={loading}
        >
            <Form form={form} layout="vertical" style={{ marginTop: 24 }}>
                <Form.Item
                    name="country"
                    label="国家/市场"
                    rules={[{ required: true, message: '请选择国家/市场' }]}
                >
                    <Select placeholder="请选择" options={COUNTRY_OPTIONS} />
                </Form.Item>

                <Form.Item
                    name="certification_type"
                    label="认证类型"
                    rules={[{ required: true, message: '请选择认证类型' }]}
                >
                    <Select placeholder="请选择" showSearch options={CERTIFICATION_TYPE_OPTIONS} />
                </Form.Item>

                <Form.Item label="证书文件">
                    <Upload
                        fileList={fileList}
                        beforeUpload={() => false}
                        onChange={({ fileList }) => onFileListChange(fileList.slice(-1))}
                        maxCount={1}
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                    >
                        <Button icon={<UploadOutlined />}>上传证书 (PDF, DOC, DOCX, 图片)</Button>
                    </Upload>
                </Form.Item>

                <Form.Item name="notes" label="备注说明">
                    <TextArea rows={3} placeholder="内部备注..." />
                </Form.Item>
            </Form>
        </Modal>
    );
};
